module.exports = __webpack_public_path__ + "static/media/alimentari profilo.9ba30023.svg";